import React from "react";
import { Zap, Milk } from "lucide-react";
import NewsletterForm from "./NewsletterForm";

/* Shared orange "drop in. milk out." newsletter section — used on every page. */
export default function NewsletterCTA({ source = "home-hero", id = "newsletter" }) {
  return (
    <section
      id={id}
      data-testid="section-newsletter"
      className="relative overflow-hidden bg-tangerine py-20 text-jet md:py-28"
    >
      {/* oversized "drop." backdrop */}
      <p className="pointer-events-none absolute inset-x-0 top-10 select-none text-center font-chunk text-[32vw] leading-none text-cream/20 md:text-[20vw]">
        drop.
      </p>

      <div className="relative mx-auto max-w-3xl px-6 text-center md:px-10">
        <span className="sticker bg-cobalt text-cream" style={{ transform: "rotate(-6deg)" }}>
          <Zap size={14} className="mr-1" /> only good emails
        </span>
        <h2 className="mt-6 font-chunk text-[14vw] leading-[0.88] text-jet md:text-[7vw] lg:text-[7rem]">
          drop in. <br />
          <span className="text-cream text-shadow-pink">milk out.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-sans text-lg font-medium md:text-xl">
          First pours, drop dates, and the occasional recipe from our
          kitchen. One email a month. Zero spam. Zero fluff.
        </p>

        <div className="mx-auto mt-10 max-w-md">
          <NewsletterForm source={source} />
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <span className="sticker bg-cream text-jet" style={{ transform: "rotate(-4deg)" }}>
            <Milk size={14} className="mr-1" /> early access
          </span>
          <span className="sticker bg-butter text-jet" style={{ transform: "rotate(3deg)" }}>
            free stickers
          </span>
          <span className="sticker bg-cobalt text-cream" style={{ transform: "rotate(-2deg)" }}>
            no spam · ever
          </span>
        </div>
      </div>
    </section>
  );
}
